<msc-common-spinner *ngIf="isLoading"></msc-common-spinner>
<div class="oneMentor">
    <iframe id="iframe" #iframe src="https://griky.1mentor.io/auth/redirect" width="100%" height="100%"></iframe>
</div>